import { Inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';

import { TranslateService } from '@ngx-translate/core';
import * as moment from 'jalali-moment';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { ImageViewerModalComponent } from '../shared/image-viewer-modal/imageViewerModal..component';

@Injectable({ providedIn: 'root' })
export class InternalService {
  temp: any;
  resourceId: any;
  userId: any;
  name: any;
  id: any;
  currency: any;
  countryId: any;
  gateWayId: any;
  allGateWays: any;


  constructor(public translate: TranslateService,
    private router: Router,
    private dialogService: NbDialogService,
    public apiService: ApiService) {
  }


  changeLang(language: string, id) {

    if (language === 'fa-ir') {
      localStorage.setItem('lang', '1');
    } else {
      localStorage.setItem('lang', '2');
    }

    // the methode for change lang and direction of whole website
    this.translate.use(language);
    this.translate.get('dir', language).subscribe(
      (res) => {
        this.apiService.currentDirection = res;
        const dom: any = document.querySelector('body');

        if (res === 'rtl' && !dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 1);
          dom.classList.toggle('rtl');

          if (id !== 0) {
            // window.location.reload();
            const currentUrl = this.router.url;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([currentUrl]);
            });


          }
        }
        if (res === 'ltr' && dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 2);
          dom.classList.toggle('rtl');
          if (id !== 0) {
            window.location.reload();
          }
        }
      },
    );
  }
  getregistrationLevel(level) {
    return (
      level == 1 ? this.translate.instant('Level1') :
        level == 2 ? this.translate.instant('Level2') :
          level == 3 ? this.translate.instant('Level3') :
            level == 4 ? this.translate.instant('Complete') :
              level == 5 ? this.translate.instant('Confirmed') : null)
  }

  viewImage(base64) {
    this.dialogService.open(ImageViewerModalComponent, {
      context: {
        image: base64,
      },
      // hasBackdrop: false,
      closeOnBackdropClick: true,
      closeOnEsc: true,
    });
  }

  // async getMd5(image) {
  //   if (image.includes('https://')) {
  //     return image;
  //   } else {
  //     const result = await this.dbService.getByIndex('Images', 'MD5', image).toPromise();
  //     if (result === undefined) {
  // // ----------------------------------------check number of rows in a store-------------------------
  //       this.dbService.count('Images').subscribe((count) => {
  //         // console.log('count', count);
  //         if (count > 100) {
  //           this.dbService.clear('Images').subscribe((successDeleted) => {
  //             // console.log('success? ', successDeleted);
  //           });
  //         }
  //       });
  // // ------------------------------------------------insert store-------------------------------------
  //       const response = await this.apiService.apiCall('get', '/api/image/GetImage/' + image, {}).toPromise();
  //       this.dbService
  //         .add('Images', {
  //           MD5: image,
  //           // icon: response['res']['imageFormat'] + response['res']['imageString'],
  //           icon: `data:image/png;base64,` + response['res']['imageString'],
  //         });
  //       return `data:image/png;base64,` + response['res']['imageString'];
  //     } else {
  //       return result.icon;
  //     }
  //   }
  // }

  getTimestamp($event) {
    if (this.apiService.currentDirection === 'rtl') {
      const dateShamsiToMiladi = moment.from(Number($event.year) + '-' + Number($event.month) +
        '-' + Number($event.day), 'fa').format('YYYY-MM-DD');
      const datemiladi = dateShamsiToMiladi.split('-');
      const UTCDate = new Date(Number(datemiladi[0]), Number(datemiladi[1]) - 1, Number(datemiladi[2]));

      return (-(UTCDate.getTimezoneOffset()) * 60) + (UTCDate.getTime() / 1000);
    } else {
      const miladi = Number($event.year) + '-' + Number($event.month) + '-' + Number($event.day);
      const datemiladi = miladi.split('-');
      const UTCDate = new Date(Number(datemiladi[0]), Number(datemiladi[1]) - 1, Number(datemiladi[2]));
      return (-(UTCDate.getTimezoneOffset()) * 60) + (UTCDate.getTime() / 1000);
    }
  }

}
